// extracted by mini-css-extract-plugin
export default {"labelForm":"Input_labelForm__k4J57"};